export default {
    cardTitle: {
        fontSize: '1.65rem',
        marginBottom: '10px',
        fontWeight: '500',
    },
};
